import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import type { PageResponse, PageResponseWithRouteMatch } from '../../models/cms';

import { CASHIER_PAGE_RESPONSE } from './cashier';

export const getPageResponse = async (
  responses: PageResponseWithRouteMatch[],
  path: string
): Promise<PageResponse | undefined> => {
  const pageResponseWithRouteMatch = responses.find((response) => response.isRouteMatch(path));
  if (!pageResponseWithRouteMatch) return undefined;
  const { isRouteMatch, ...pageResponse } = pageResponseWithRouteMatch;
  return pageResponse;
};

export const getLocalPage = async (
  rootState: RootState,
  path: string
): Promise<PageResponse | undefined> => {
  if (select.cms.isIspRouting(rootState) && path.startsWith('/sports/')) {
    const { getResponses } = await import('@swf/sports/pages/sports');
    const matchedPage = await getPageResponse(getResponses(rootState), path);
    return matchedPage;
  }
  if (path.includes('/cashier')) {
    return CASHIER_PAGE_RESPONSE;
  }
};
